module.exports = __webpack_public_path__ + "static/media/icon-chevron-active.11843254.svg";